function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Rewards = function Rewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M17.35 1.924c.688.621 1.106 1.63 1.118 2.696a3.23 3.23 0 0 1-.52 1.775H20.5a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h3.013a3 3 0 0 1-.435-1.571c.01-.987.399-1.921 1.039-2.5 1.26-1.136 3.193-1.142 4.498-.017q.135.117.263.247c.196-.247.401-.46.618-.648C13.906.692 15.991.7 17.35 1.924M11 8.394H4.5v13H11zm8.5 0H13v13h6.5zM8.456 3.81c-.225.203-.374.61-.378 1.033-.006.644.7 1.192 1.33 1.552H11V4.687a1 1 0 0 1-.113-.154 2.9 2.9 0 0 0-.578-.712c-.534-.463-1.348-.468-1.853-.012m5.347-.39a3.3 3.3 0 0 0-.665.821l-.094.146-.044.066v1.941l2.05.001c.695-.415 1.425-1.027 1.418-1.755-.006-.5-.186-.984-.458-1.23-.602-.542-1.572-.537-2.207.01"
  }));
};
export default Rewards;